var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCampDoctorChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVG"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.5 4.16667L13.3333 10L7.5 15.8333",
    strokeWidth: 2.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#94A3B8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampDoctorChevron);
export default __webpack_public_path__ + "static/media/camp-doctor-chevron.84f1fdd1286f0f618b036ec39898397d.svg";
export { ForwardRef as ReactComponent };